import { Injectable } from '@angular/core';
import { BinEvent } from '../interfaces/bin-event';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BinEventCrudService {

  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/binEvents/' ;
  }

  getOrganisation() : string | null {
    const company = JSON.parse(localStorage.getItem('organisation')!);
    if (company && typeof company.$key !== 'undefined') {
        return company.$key;
    }
    return null;
  }

  getBin() : string | null {
    const bin = JSON.parse(localStorage.getItem('bin')!);
    if(bin && typeof bin.$key !== 'undefined') {
      return bin.$key;
    }
    return null;
  }

  // Create Bin
  add(record: BinEvent) {
    const org = this.getOrganisation();
    const bin =  this.getBin();
    if (!org) {
      return;
    } 
    this.refs = this.db.list( 'organisations/' + org + '/' + this.path + bin);
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Bin Object
  get(id: string) {
    const org = this.getOrganisation();
    const bin =  this.getBin();
    if (!org) {
      return {} as AngularFireObject<any>;
    }  
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + bin + '/' + id);
    return this.ref;
  }
  // Fetch Bins List
  getList() {
    const org = this.getOrganisation();
    const bin =  this.getBin();
    if (!org) {
      return {} as AngularFireList<any>;
    } 
    this.refs = this.db.list( 'organisations/' + org + '/' + this.path + bin);
    return this.refs;
  }
  // Update Bin Object
  update(record: BinEvent) {
    const org = this.getOrganisation();
    const bin =  this.getBin();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + bin + '/' + record.$key);
    let item : Partial<BinEvent>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Bin Object
  delete(id: string) {
    const org = this.getOrganisation();
    const bin =  this.getBin();
    if (!org) {
      return;
    } 
    this.ref = this.db.object( 'organisations/' + org + '/' + this.path + bin + '/' + id);
    this.ref.remove();
  }
}